module.exports = __webpack_public_path__ + "static/media/open-sans-v17-latin-ext_latin-700italic.25903c62.eot";